// Screen `clause-library` (owner: doc-variants, owner feedback F12): named clauses with approved alternatives.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ClauseLibraryPage } from '../../../features/doc-variants/ClauseLibrary';

const Search = z.object({ clause: z.string().max(63).optional().catch(undefined) });

export const Route = createFileRoute('/_app/documents/clauses')({
  validateSearch: Search,
  component: ClausesRoute,
});

function ClausesRoute() {
  const { clause } = Route.useSearch();
  return <ClauseLibraryPage selected={clause ?? null} />;
}
